import React from 'react';
import { Button } from '../../Button/Button';
import { IActionsBoxItem } from './IActionsBoxItem';
import { Container } from './styles';

interface IActionsBoxProps {
  actions: IActionsBoxItem[];
  defaultItemWidth?: string;
  loading?: boolean;
  click?: (key: string) => void;
}

export const ActionsBox: React.FC<IActionsBoxProps> = ({
  actions: items,
  defaultItemWidth,
  loading,
  click
}) => {

  return (
    <Container>
      {items.map((item, index) => {
        const dataKey = `action_${item.key}`;
        return (
          <Button
            key={dataKey}
            text={item.text}
            click={() => click && click(item.key)}
            marginLeft={index > 0 ? '10px' : '0px'}
            width={item.minWidth || defaultItemWidth}
            disabled={loading}
          />
        );
      })}
    </Container>
  );
}